var navigators = {
	init: function(){
		this.nav();
		setTimeout(function(){
			$(".block_n.a").eq(0).addClass("animate");
		},600);
	},
	nav: function(){
		$("#nav_navigator li a").off().on("click", function(){
			let idx = $("#nav_navigator li a").index(this),
				$blk = $(".block_n").eq(idx);
			if($blk.hasClass("animate")){
				var posY = $blk.offset().top - $("header").height();
			}else{
				var posY = $blk.offset().top - $("header").height() - 20;
			}
			
			common.scrollToPosition(posY, 1000);
		});
		$(".block_n .pagetop a").off().on("click", function(){
			common.scrollToPosition(0,1000);
		});
		/*
		$(".block_n li a").off().on("click", function(e){
			e.preventDefault();
			let url = $(this).attr("href");
			console.log(url);
		});
		*/
	}
}